import { axiosClient, axiosClientWithToken } from "./api.client";

const apiOrder = {
  createOrder: async (params) => {
    try {
      const res = await axiosClientWithToken.post(`/order/create`, params);
      return res.data;
    } catch (error) {
      console.error("Error fetching shows:", error);
    }
  },

  getTicketsByOrderId: async (orderId) => {
    try {
      const res = await axiosClientWithToken.get(`/order/payment/${orderId}`, {
        withCredentials: true,
      });
      return res.data;
    } catch (error) {
      console.log(error);
    }
  },

  getOrderDetalsByUserId: async () =>{
    try{
      const res = await axiosClientWithToken.get(`/order/details`)
      return res.data
    }
    catch(error){
      console.log(error);
    }
  },


  updateOrderSuccess: async (orderId) =>{
    try{
      const res = await axiosClient.get(`/order/success/${orderId}`);
      return res.data;
    }catch(error){
      console.log(error)
    }
  },

  updateOrderFailure: async (orderId) =>{
    try{
      const res = await axiosClient.get(`/order/failure/${orderId}`);
      return res.data;
    }catch(error){
      console.log(error)
    }
  }
};
export default apiOrder;
